module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS7.200f7a93.jpg";